import React from "react"
import { graphql } from "gatsby"
import Helmet from "react-helmet"
import Meta from "../components/Meta"
import Article from "../components/article/Article"
import SchemaReportageNewsArticle from "../components/schema/ReportageNewsArticle";
import MabaniInvestigation from "../components/mabani/MabaniInvestigation"

import ArticleCanonical from "../components/article/ArticleCanonical"
import getArticlePath from "../components/article/getArticlePath"

const ArticlePage = ({ data, pageContext }) => {

  const article = data.directus.articles_by_id;
  article.content = data?.wpPost?.content;

  return (
    <>
      {article.slug === "the-secretive-libyan-prisons-that-keep-migrants-out-of-europe" ? (
        <MabaniInvestigation />
      ) : (
        <>
          <Meta
            type="article"
            title={`${article.title} | ${data.site.siteMetadata.title}`}
            description={article.excerpt}
            uri={getArticlePath(article)}
            image={article.image.imageFile.publicURL}
    
          />
          {article?.canonical_syndication?.url && <ArticleCanonical url={article.canonical_syndication.url} />}
          <main>
            <Article article={article} />
            {/*
            <SchemaReportageNewsArticle
              headline={data.post.title}
              abstract={data.post.excerpt}
              image={data.post.featuredImage.node.localFile.publicURL}
              uri={data.post.uri}
            />*/}
          </main>
        </>
      )}
    </>
  )
}

export default ArticlePage;


export const query = graphql`
  query($id: ID!, $wordpress_id: Int!) {
    site {
      id
      siteMetadata {
          title
      }
    }

    wpPost(databaseId: { eq: $wordpress_id }) {
      content
    }

    directus {
      articles_by_id(id: $id) {
        authors {
          members_id {
            author_slug
            first_name
            last_name
          }
        }
        canonical_syndication {
          outlet {
            name
          }
          title
          url
        }
        date_published
        excerpt
        id
        image {
          id
          imageFile {
            childImageSharp {
              gatsbyImageData(width: 2048)
            }
            publicURL
          }
        }

        short_title
        syndications(sort: "article_sort") {
          item_type
          language {
            code
            id
            name
          }
          medium {
            name
          }
          outlet {
            id
            name
            sort
            country {
              coordinates
              id
              name
            }
          }
          id
          title
          url
        }
        slug
        title
        video_url
        subsection
        section
      }
    }
  }
`;

/*

        parent {
          slug
          section
          short_title
          title
          image {
            id
            imageFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          children(
            filter: {
              is_hidden: {_neq: true}
            }
            sort: "date_published"
          ) {
            title
            slug
            subsection
            section
            parent {
              slug
            }
            image {
              id
              imageFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
        }
        */